import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Layout } from '../components/Layout/Layout';
import { MarkdownEditor } from '../components/Editor/MarkdownEditor';
import { useDocsStore } from '../store/docsStore';
import '../styles/page.css';

export const NewDocPage: React.FC = () => {
  const navigate = useNavigate();
  const isOnline = useDocsStore((state) => state.isOnline);

  // Redirect if offline
  useEffect(() => {
    if (!isOnline) {
      navigate('/');
    }
  }, [isOnline, navigate]);

  return (
    <Layout showSidebar={false}>
      <div className="page-header">
        <h1 className="page-title">Create New Document</h1>
        <p className="page-subtitle">Write beautiful documentation with markdown</p>
      </div>
      <MarkdownEditor mode="create" />
    </Layout>
  );
};
